import $ from 'jquery';

export function geolocation(endpoint) {
	return new Promise((resolve) => {

		// Check for geolocation support
		if (!window.navigator.geolocation || !endpoint) {
			return resolve();
		}

		window.navigator.geolocation.getCurrentPosition(pos => {
			$.get(
				endpoint,
				{
					'latitude': pos.coords.latitude,
					'longitude': pos.coords.longitude
				},
				data => {
					// All fine, go ahead
					return resolve(data);
				}
			).fail(() => {
				// If something went wrong with the location API
				return resolve();
			});
		}, () => {
			// If something went wrong or permission is denied
			return resolve();
		});
	});
}

export function location(endpoint, zipcode) {
	return new Promise((resolve) => {
		const re = /^\d{2,5}$/;

		if (!re.test(zipcode)) {
			return resolve();
		}

		$.get(
			endpoint,
			{
				'zipcode': zipcode
			},
			data => {
				// All fine, go ahead
				return resolve(data);
			}
		).fail(() => {
			// If something went wrong with the location API
			return resolve();
		});
	});
}

export function subcategories(endpoint, category_id) {
	return new Promise((resolve) => {
		$.get(
			endpoint,
			{
				'category_id': category_id
			},
			data => {
				// All fine, go ahead
				return resolve(data);
			}
		).fail(() => {
			// If something went wrong with the location API
			return resolve();
		});
	});
}
